import { MapsAPILoader } from '@agm/core';
import { AfterViewInit, Component, ElementRef, NgZone, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import Stepper from 'bs-stepper';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { CatalogoTablaService } from 'src/app/data/catalogoTabla.service';
import { EmpresaAfiliadaService } from 'src/app/data/empresasAfiliadas.Service';
import { ProyectoService } from 'src/app/data/proyecto.service';
import { UsuariosService } from 'src/app/data/usuarios.service';
import { CatalogoTabla } from 'src/app/models/catalogoTablas';
import { EmpresasAfiliadas } from 'src/app/models/empresasAfiliadas';
import { Modelo } from 'src/app/models/modelo';
import { Proyecto } from 'src/app/models/proyecto';
import { Usuario } from 'src/app/models/usuario';
import { VentajaProyecto } from 'src/app/models/ventaja-proyecto';

import * as $ from 'jquery';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PerfilamientoMasterRespuestasHijas } from 'src/app/models/perfilamientoMasters/perfilamientoMasterRespuestasHija';
import { PerfilamientoMasterService } from 'src/app/data/perfilamientoMasters/perfilamientoMaster.service';

@Component({
  selector: 'app-nuevo-proyecto',
  templateUrl: './nuevo-proyecto.component.html',
  styleUrls: ['./nuevo-proyecto.component.scss'],
})


export class NuevoProyectoComponent implements OnInit, AfterViewInit {


  name = 'Angular';
  private stepper: Stepper;

  existeImagen: boolean = false;
  imagen: File;
  imagenUrl: string;


  existeLogoP: boolean = false;
  logoPUrl: string;
  logoP: File;

  existeBanner: boolean = false;
  bannerUrl: string;
  banner: File;
  tiposProyecto: CatalogoTabla[];
  tiposVenta: CatalogoTabla[];
  modalInfoRef: BsModalRef;
  modelos: Modelo[] = [];

  precioModelo: any = 0;

  amenidades: VentajaProyecto[] = [];

  existeImagenM: boolean = false;
  modeloUrl: string;
  modelo: File;

  existeImagenA: boolean = false;
  amenidadUrl: string;
  amenidad: File;


  proyectoSubmit = new Proyecto();
  empresaSubmit = new EmpresasAfiliadas();
  modeloSubmit = new Modelo();
  amenidadSubmit = new VentajaProyecto();
  usuarioSubmit = new Usuario();

  fin: boolean = false;


  @ViewChild('myTextarea') myTextarea!: ElementRef<HTMLTextAreaElement>;
  modalRef: BsModalRef;

  modalRefEmpresa: BsModalRef;



  step0 = false;
  step1 = false;
  step2 = false;
  step3 = false;
  tabModelos = false;
  step4 = false;
  omitir = false;
  tabAmenidades = true;

  tycAceptar: boolean = false;

  disabledEmpresa: boolean = false;

  public latitude: number;
  public longitude: number;
  public searchControl: FormControl;
  public zoom: number;

  public latitude1: number;
  public longitude1: number;
  public searchControl1: FormControl;
  public zoom1: number;

  listaModelos: boolean = true;
  listaAmenidades: boolean = true;

  @ViewChild('stepperContainer') stepperContainer: ElementRef;


  Lada: string = "";
  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required])
  });


  proyectoService: ProyectoService;

  mapStyles = [
    {
      "featureType": "administrative",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#444444"
        }
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "all",
      "stylers": [
        {
          "color": "#edeff2"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "all",
      "stylers": [
        {
          "saturation": -100
        },
        {
          "lightness": 45
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "simplified"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "all",
      "stylers": [
        {
          "color": "#dce3ef"
        },
        {
          "visibility": "on"
        }
      ]
    }
  ];

  @ViewChild("search")
  public searchElementRef: ElementRef;

  @ViewChild("search1")
  public searchElementRef1: ElementRef;

  formUsuario: FormGroup;
  formDesarrolladora: FormGroup;
  formProyecto: FormGroup;
  formModelo: FormGroup;
  formAmenidad: FormGroup;
  minDate = new Date();


  guardando: boolean = false;

  amenidadesCatalogo: PerfilamientoMasterRespuestasHijas[] = [];

  sinAmenidades: boolean = false;


  constructor(
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private empresasService: EmpresaAfiliadaService,
    private usuarioService: UsuariosService,
    proyectoService: ProyectoService,
    private modalService: BsModalService,
    public perfilamientoMasterService: PerfilamientoMasterService,
    private catalogoTablaService: CatalogoTablaService,
    private sanitizer: DomSanitizer
  ) {
    this.proyectoService = proyectoService;

    this.formDesarrolladora = new FormGroup({
      nombre: new FormControl('', [Validators.required]),
      proyectos: new FormControl('', [Validators.required]),
      experiencia: new FormControl('', [Validators.required]),
      direccion: new FormControl('', [Validators.required]),
      imagen: new FormControl('', [Validators.required]),
      latitud: new FormControl('', [Validators.required]),
      longitud: new FormControl('', [Validators.required]),
      idEmpresaAfiliada: new FormControl('',),
    });

    this.formProyecto = new FormGroup({
      idProyecto: new FormControl('',),
      idUsuario: new FormControl('',),
      idEmpresaAfiliada: new FormControl('',),
      nombreProyecto: new FormControl('', [Validators.required]),
      descripcionProyecto: new FormControl('', [Validators.required]),
      logo: new FormControl('', [Validators.required]),
      portada: new FormControl('', [Validators.required]),
      tipoProyecto: new FormControl('', [Validators.required]),
      tipoVenta: new FormControl('', [Validators.required]),
      inventario: new FormControl('', [Validators.required]),
      tiempoEntrega: new FormControl('', [Validators.required]),
      direccion: new FormControl('', [Validators.required]),
      latitud: new FormControl('', [Validators.required]),
      longitud: new FormControl('', [Validators.required]),
      estatus: new FormControl('',),
    });

    this.formModelo = new FormGroup({
      idModelo: new FormControl('',),
      idProyecto: new FormControl('',),
      idEmpresaAfiliada: new FormControl('',),
      nombre: new FormControl('', [Validators.required]),
      precioModelo: new FormControl('', [Validators.required]),
      areas: new FormControl('', [Validators.required]),
      recorrido: new FormControl('',),
      banos: new FormControl('',),
      recamaras: new FormControl('',),
      estacionamientos: new FormControl('',),
      precio: new FormControl('',),
      imagen: new FormControl('', [Validators.required]),
    });

    this.formAmenidad = new FormGroup({
      idAmenidad: new FormControl('',),
      idProyecto: new FormControl('',),
      idIcono: new FormControl('',),
      idEmpresaAfiliada: new FormControl('',),
      nombre: new FormControl(''),
      amenidadSelect: new FormControl('', [Validators.required]),
    });

    this.formUsuario = new FormGroup({
      idEmpresaAfiliada: new FormControl('',),
      nombre: new FormControl('', [Validators.required]),
      telefono: new FormControl('', [Validators.required]),
      correo: new FormControl('', [Validators.required]),
    });


    var perfilamiento = new PerfilamientoMasterRespuestasHijas();
    perfilamiento.idRespuestaPadre = 1;
    this.perfilamientoMasterService.recuperaPerfilamientoMasterRespuestasHijas(perfilamiento).subscribe(data => {
      this.amenidadesCatalogo = data;
    }, error => {
      console.log(error)
    });

    const catalogo = new CatalogoTabla();
    catalogo.tabla = 'PROYECTO';
    catalogo.idCatalogoTabla = -1;
    catalogo.valor = '';
    this.catalogoTablaService.recuperaCatalogoTablas(catalogo).subscribe(
      data => {
        console.log("Catalogo: ", data);
        this.tiposProyecto = data;
      }
    );

    const catalogoVenta = new CatalogoTabla();
    catalogoVenta.tabla = 'TIPO_VENTA';
    catalogoVenta.idCatalogoTabla = -1;
    catalogoVenta.valor = '';
    this.catalogoTablaService.recuperaCatalogoTablas(catalogoVenta).subscribe(
      data => {
        console.log("Catalogo: ", data);
        this.tiposVenta = data;
      }
    );


  }


  ngAfterViewInit() {
    $(document).ready(function () {
      var element = $(".iti");
      if (element.length > 0) {
        element.css("width", "100%");
      }
    });
  }

  acpetaTyC($event) {
    this.tycAceptar = $event.target.checked;
  }


  next() {
    this.stepper.next();
    this.step3 = true;
    this.omitir = true;
    this.tabModelos = false;
    this.tabAmenidades = true;
    this.hacerScroll();

  }

  terminar(template: TemplateRef<any>) {
    this.step4 = true;
    this.tabModelos = false;
    this.fin = true;
    this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
  }

  guardaUsuario(template: TemplateRef<any>) {
    console.log(this.formUsuario.controls);
    this.guardando = true;

    this.usuarioSubmit = this.formUsuario.value;
    this.usuarioSubmit.idEmpresaAfiliada = -1;
    this.usuarioSubmit.login = this.formUsuario.controls['correo'].value;

    //
    this.empresasService.recuperaEmpresaUsuarioPendiente(this.usuarioSubmit.login, this.formUsuario.value.telefono.number).subscribe((res) => {
      if (res != null) {
        this.modalRefEmpresa = this.modalService.show(template, { class: 'modal-md' });

        this.empresaSubmit = res;
        this.formProyecto.controls['idEmpresaAfiliada'].setValue(res.idEmpresaAfiliada);
        this.formUsuario.controls['idEmpresaAfiliada'].setValue(res.idEmpresaAfiliada);
        this.formDesarrolladora.controls['idEmpresaAfiliada'].setValue(res.idEmpresaAfiliada);

        this.guardando = false;
        this.step0 = true;
        this.step1 = true;
        this.disabledEmpresa = true;
        this.stepper.to(3);
        this.hacerScroll();
      } else {
        this.guardando = false;
        this.step0 = true;
        this.stepper.next();
        this.hacerScroll();
      }
    });



  }

  guardaDesarrolladora() {
    this.guardando = true;
    this.empresaSubmit = this.formDesarrolladora.value;
    this.empresasService.guardaEmpresaAfiliada(this.formDesarrolladora, this.imagen).then((res) => {
      this.formProyecto.controls['idEmpresaAfiliada'].setValue(res.idEmpresaAfiliada);
      this.empresaSubmit.idEmpresaAfiliada = res.idEmpresaAfiliada;
      console.log("Empresa guardada: ", res.idEmpresaAfiliada);
      this.formUsuario.controls['idEmpresaAfiliada'].setValue(res.idEmpresaAfiliada);
      //guarda el usuario ya con su id de empresa afiliada
      this.usuarioService.guardaUsuarioPendiente(this.formUsuario).then(
        data => {
          console.log("Usuario guardado: ", data);
          this.guardando = false;
          this.step1 = true;
          this.stepper.next();
        }
      );



    }).catch((err) => {
      console.log(err);
      this.guardando = false;
    });
    // setTimeout(() => {
    //   this.guardando = false;
    //   this.step1 = true;
    //   this.stepper.next();
    // }
    //   , 2000);

  }

  guardaProyecto() {
    this.guardando = true;
    console.log(this.formProyecto.controls);
    console.log("Formulario válido✅");
    this.formProyecto.controls['idProyecto'].setValue(-1);
    this.formProyecto.controls['idUsuario'].setValue(-1);
    this.formProyecto.controls['estatus'].setValue('PENDIENTE');
    this.proyectoSubmit = this.formProyecto.value;

    this.proyectoService.guardaProyectoPendiente(this.formProyecto).then(
      (response) => {
        console.log(response);
        this.formProyecto.controls['idProyecto'].setValue(response.idProyecto);
        this.proyectoSubmit = response;

        this.step2 = true;
        this.tabModelos = true;
        this.guardando = false;
        this.stepper.next();
        this.hacerScroll();

      }
    );

    // setTimeout(() => {
    //   this.guardando = false;
    //   this.step2 = true;
    //   this.stepper.next();
    // }
    //   , 2000);
  }

  guardaModelo() {
    this.guardando = true;
    console.log(this.formModelo.controls);
    console.log("Formulario válido✅");
    this.formModelo.controls['idModelo'].setValue(-1);
    this.formModelo.controls['idProyecto'].setValue(this.formProyecto.controls['idProyecto'].value);
    this.formModelo.controls['idEmpresaAfiliada'].setValue(this.formProyecto.controls['idEmpresaAfiliada'].value);
    // this.formModelo.controls['idProyecto'].setValue(74);
    // this.formModelo.controls['idEmpresaAfiliada'].setValue(38);ç
    var precio = this.formModelo.controls['precioModelo'].value;
    //remove all characters except numbers
    precio = precio.replace(/\D/g, '');
    this.formModelo.controls['precio'].setValue(precio);
    this.formModelo.controls['precioModelo'].setValue(precio);



    this.modeloSubmit = this.formModelo.value;
    console.log(this.modeloSubmit);

    this.proyectoService.guardaModelo(this.modeloSubmit, this.modelo).then(
      (response) => {
        console.log(response);
        this.step3 = true;
        this.guardando = false;
        this.modelos.push(response);
        this.listaModelos = true;
      }
    );

  }

  omitirAmenidades() {
    this.sinAmenidades = true;
    this.omitir = false;
  }

  guardaAmenidad() {
    this.guardando = true;
    console.log("Formulario válido✅");
    this.formAmenidad.controls['idAmenidad'].setValue(-1);
    this.formAmenidad.controls['idProyecto'].setValue(this.formProyecto.controls['idProyecto'].value);
    this.formAmenidad.controls['idEmpresaAfiliada'].setValue(this.formProyecto.controls['idEmpresaAfiliada'].value);
    this.formAmenidad.controls['nombre'].setValue(this.formAmenidad.controls['amenidadSelect'].value.descripcionRespuesta);
    this.formAmenidad.controls['idIcono'].setValue(this.formAmenidad.controls['amenidadSelect'].value.idRespuestaHija);

    this.amenidadSubmit = this.formAmenidad.value;

    console.log(this.amenidadSubmit);


    this.proyectoService.guardaVentajaProyecto(this.amenidadSubmit).then(
      (response) => {
        console.log(response);
        this.step4 = true;
        this.guardando = false;
        this.amenidades.push(response);
        this.listaAmenidades = true;
      }
    );
  }

  ngOnInit() {
    this.stepper = new Stepper(document.querySelector('#stepper1'), {
      linear: false,
      animation: true
    })

    //set google maps defaults
    this.zoom = 10;
    this.latitude = 25.5486137;
    this.longitude = -103.4019159;

    //set google maps defaults 1
    this.zoom1 = 10;
    this.latitude1 = 25.5486137;
    this.longitude1 = -103.4019159;

    //create search FormControl
    this.searchControl = new FormControl();

    this.searchControl1 = new FormControl();


    //set current position
    this.setCurrentPosition();

    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["establishment"]
      });
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          this.formDesarrolladora.controls.direccion.setValue(place.formatted_address);
          this.formDesarrolladora.controls.latitud.setValue(place.geometry.location.lat());
          this.formDesarrolladora.controls.longitud.setValue(place.geometry.location.lng());
          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 16;
        });
      });
    });

    //load Places Autocomplete 1
    this.mapsAPILoader.load().then(() => {
      let autocomplete1 = new google.maps.places.Autocomplete(this.searchElementRef1.nativeElement, {
        types: ["establishment"]
      });
      autocomplete1.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place1: google.maps.places.PlaceResult = autocomplete1.getPlace();
          this.formProyecto.controls.direccion.setValue(place1.formatted_address);
          this.formProyecto.controls.latitud.setValue(place1.geometry.location.lat());
          this.formProyecto.controls.longitud.setValue(place1.geometry.location.lng());
          //verify result
          if (place1.geometry === undefined || place1.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.latitude1 = place1.geometry.location.lat();
          this.longitude1 = place1.geometry.location.lng();
          this.zoom1 = 16;
        });
      });
    });


  }


  private setCurrentPosition() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 12;

        this.latitude1 = position.coords.latitude;
        this.longitude1 = position.coords.longitude;
        this.zoom1 = 12;
      });
    }
  }


  inputDireccion($e) {
    console.log($e.target.value);
    this.formDesarrolladora.controls.direccion.setValue($e.target.value);

  }


  uploadImagen(event) {
    this.imagen = event.target.files[0];
    console.log(this.imagen);
    //agregar name al archivo
    const reader = new FileReader();
    reader.onload = e => this.imagenUrl = reader.result as string;
    reader.readAsDataURL(this.imagen);
    console.log(this.imagen);
    this.formDesarrolladora.controls['imagen'].setValue(this.imagen);
    this.existeImagen = true;
    console.log(this.formDesarrolladora.value);
  }

  uploadLogoP(event) {
    this.logoP = event.target.files[0];
    //agregar name al archivo
    const reader = new FileReader();
    reader.onload = e => this.logoPUrl = reader.result as string;
    reader.readAsDataURL(this.logoP);
    console.log(this.logoP);
    this.formProyecto.controls['logo'].setValue(this.logoP);
    this.existeLogoP = true;
  }

  uploadBanner(event) {
    this.banner = event.target.files[0];
    console.log(this.banner);
    //agregar name al archivo
    const reader = new FileReader();
    reader.onload = e => this.bannerUrl = reader.result as string;
    reader.readAsDataURL(this.banner);
    console.log(this.banner);
    this.formProyecto.controls['portada'].setValue(this.banner);
    this.existeBanner = true;
  }

  uploadImagenM(event) {
    this.modelo = event.target.files[0];
    console.log(this.modelo);
    //agregar name al archivo
    const reader = new FileReader();
    reader.onload = e => this.modeloUrl = reader.result as string;
    reader.readAsDataURL(this.modelo);
    console.log(this.modelo);
    this.formModelo.controls['imagen'].setValue(this.modelo);
    this.existeImagenM = true;
    console.log(this.formModelo.value);
  }

  uploadImagenA(event) {
    this.amenidad = event.target.files[0];

    //agregar name al archivo
    const reader = new FileReader();
    reader.onload = e => this.amenidadUrl = reader.result as string;
    reader.readAsDataURL(this.amenidad);
    console.log(this.amenidad);
    this.formAmenidad.controls['imagen'].setValue(this.amenidad);
    this.existeImagenA = true;
    console.log(this.formAmenidad.value);
  }

  clearBanner() {
    this.banner = null;
    this.bannerUrl = null;
    this.existeBanner = false;
    this.formDesarrolladora.controls['banner'].setValue(null);
  }

  clearLogoP() {
    this.logoP = null;
    this.logoPUrl = null;
    this.existeLogoP = false;
    this.formDesarrolladora.controls['logo'].setValue(null);
  }

  clearImagen() {
    this.imagen = null;
    this.imagenUrl = null;
    this.existeImagen = false;
    this.formDesarrolladora.controls['imagen'].setValue(null);
  }

  clearImagenM() {
    this.modelo = null;
    this.modeloUrl = null;
    this.existeImagenM = false;
    this.formModelo.controls['imagen'].setValue(null);
  }

  clearImagenA() {
    this.amenidad = null;
    this.amenidadUrl = null;
    this.existeImagenA = false;
    this.formAmenidad.controls['imagen'].setValue(null);
  }

  moveCursorToStart(textarea: HTMLTextAreaElement) {
    textarea.focus();
    textarea.setSelectionRange(0, 0);
  }


  agregarModelo() {
    this.tabModelos = true;

    this.listaModelos = !this.listaModelos;
    this.formModelo.reset();
    this.clearImagenM();
  }

  agregarAmenidad() {
    this.sinAmenidades = false;
    this.tabAmenidades = true;
    this.omitir = false;
    this.listaAmenidades = !this.listaAmenidades;
    this.formAmenidad.reset();
    this.clearImagenA();
  }

  validateTelefono(control: FormControl) {
    const telefono = control.value;

    // Comprueba si el valor es un número y tiene una longitud de 10 dígitos
    if (telefono && isNaN(Number(telefono)) || telefono.length !== 10) {
      return { telefonoInvalido: true };
    }

    return null;
  }

  titulo: string;
  descripcion: string;
  descripcionConSaltosDeLinea: SafeHtml;
  info(template: TemplateRef<any>, tipo: number) {
    //open right away

    if (tipo == 1) {
      this.titulo = "¿Qué es la portada del proyecto?";
      this.descripcion = "La portada del proyecto es la imagen principal que representa visualmente tu desarrollo inmobiliario. Es la primera impresión que los interesados tendrán sobre tu proyecto, y es clave para atraer su atención. \n\n Al ingresar la imagen para la portada, asegúrate de seleccionar una que refleje la esencia y las características destacadas de tu proyecto. \nNuestro equipo trabajará en conjunto contigo para asegurarnos de que la portada sea atractiva y profesional, capturando la esencia de tu desarrollo y transmitiendo la información clave de manera efectiva. \n\n¡Estamos emocionados de ayudarte a destacar y promover tu proyecto con una portada impactante!. Esta imagen debe ser de 1920 x 1080 pixeles.";

      // Procesamos el texto para mostrar los saltos de línea correctamente
      this.descripcionConSaltosDeLinea = this.sanitizer.bypassSecurityTrustHtml(this.descripcion.replace(/\n/g, "<br>"));

    } else if (tipo == 2) {
      this.titulo = "¿Qué es el tipo de proyecto?";
      this.descripcion = "En este campo, te solicitamos seleccionar el tipo de proyecto que mejor refleje la naturaleza de tu desarrollo inmobiliario. La elección que realices aquí es esencial, ya que nos permitirá comprender la categoría a la que pertenece tu proyecto y adaptar nuestros servicios para brindarte el mejor apoyo posible. \n\nLas opciones disponibles incluyen una variedad de tipos de proyectos, tales como departamentos, lotes, terrenos, viviendas unifamiliares y otros. Te animamos a que selecciones la opción que se ajuste más a la estructura y propósito de tu proyecto, para que podamos comprender en detalle su enfoque y características. \n\nSi tienes algún tipo de proyecto que no esté incluido en las opciones proporcionadas, no dudes en comunicárnoslo, estaremos encantados de agregarlo. Nuestro objetivo es facilitar tu experiencia y brindarte soluciones personalizadas para que tu proyecto inmobiliario alcance su máximo potencial. Recuerda que este campo es de suma importancia para el análisis de tu proyecto, por lo que te recomendamos seleccionar cuidadosamente la opción que mejor se ajuste a tu visión y objetivos. Estamos emocionados de trabajar contigo y ser parte del éxito de tu proyecto.";

      // Procesamos el texto para mostrar los saltos de línea correctamente
      this.descripcionConSaltosDeLinea = this.sanitizer.bypassSecurityTrustHtml(this.descripcion.replace(/\n/g, "<br>"));

    } else if (tipo == 3) {
      this.titulo = "¿Qué es el tipo de venta?";
      this.descripcion = "En este campo, te solicitamos que elijas el tipo de venta que mejor se adapte a tu desarrollo inmobiliario: Preventa o Inventario. Ambas opciones tienen características únicas y pueden ser apropiadas según el estado y enfoque de tu proyecto.\n\n" +

        "Preventa: La Preventa es una fase temprana en la que se ofrecen unidades inmobiliarias antes de que el proyecto esté completamente finalizado. Es una oportunidad emocionante para generar interés anticipado y captar clientes potenciales que deseen asegurar una propiedad a precios preferenciales. Durante esta etapa, el proyecto aún está en construcción, lo que permite a los compradores personalizar detalles y obtener condiciones especiales de compra.\n\n" +

        "Inventario: La opción de Inventario representa unidades que ya están construidas y disponibles para su venta inmediata. Estás unidades suelen estar listas para ser entregadas a los compradores, lo que puede ser atractivo para aquellos que buscan mudarse o invertir sin tener que esperar la construcción. \n\nLa disponibilidad inmediata y la certeza de la propiedad son los aspectos clave de esta opción." +

        "Nuestro equipo trabajará contigo para entender tus objetivos y asesorarte sobre cuál es la mejor opción de venta para tu proyecto. Ya sea Preventa o Inventario, nos entusiasma ser parte de tu éxito y brindarte el apoyo necesario para alcanzar tus metas en el mercado inmobiliario.";
      this.descripcionConSaltosDeLinea = this.sanitizer.bypassSecurityTrustHtml(this.descripcion.replace(/\n/g, "<br>"));

    } else if (tipo == 4) {
      this.titulo = "¿Qué son el número de unidades?";
      this.descripcion = "En este campo, por favor, ingresa la cantidad total de unidades que conformarán tu proyecto inmobiliario en inventario. El número de unidades es un aspecto clave que determinará la escala de tu desarrollo y su disponibilidad para la venta inmediata.\n\n" +

        "Al ingresar este dato, es importante tener en cuenta la viabilidad y alcance de tu proyecto. Asegúrate de proporcionar una cifra precisa y realista que refleje la cantidad exacta de unidades disponibles para su venta en la fase de inventario. Esta información será de gran utilidad para planificar y organizar estrategias de comercialización y distribución.\n" +

        "Nuestro equipo estará atento a tus requerimientos y trabajará para ofrecerte soluciones que se adapten a la cantidad de unidades que has ingresado. Ya sea un desarrollo pequeño o una comunidad de gran escala, estamos comprometidos a brindarte el apoyo necesario para que tu proyecto inmobiliario alcance su máximo potencial.\n" +

        "Recuerda que la cantidad de unidades es un factor determinante para el éxito de tu proyecto, y estamos entusiasmados de colaborar contigo en cada paso del camino hacia el logro de tus objetivos en el mercado inmobiliario.";
      this.descripcionConSaltosDeLinea = this.sanitizer.bypassSecurityTrustHtml(this.descripcion.replace(/\n/g, "<br>"));

    }

    this.modalInfoRef = this.modalService.show(template, { class: 'modal-right' });
  }

  enviarCorreo() {
    this.guardando = true;
    this.proyectoService.notificaProyectpoPendiente(this.usuarioSubmit).subscribe(
      response => {
        this.guardando = false;
        this.modalRef.hide();
        //close tab
        window.location.href = "https://io.reda.mx/";

      }
    );

  }


  hacerScroll() {
    const scrollAmount = 10; // Cantidad de desplazamiento en píxeles que deseas

    // Realiza el desplazamiento en el contenedor del stepper
    if (this.stepperContainer && this.stepperContainer.nativeElement) {
      this.stepperContainer.nativeElement.scrollTop += scrollAmount;
    }
  }

  tyc() {
    window.open('https://io.reda.mx/politicas-de-privacidad/', '_blank');
  }

  ayuda() {
    window.open('https://proyectos.reda.mx/t2/?IdProyecto=55&v=emM1WIYnLBPssgkn6vF/htP/IC8t4WocZ+ytorSkUi1tVcME921PodQKL1qNx9+rwIhxmzBYbK19fTIse2joZA==&c=Le555916', '_blank');
  }
}


//clase de TipoVenta
export class TipoVenta {
  id: number;
  nombre: string;
}
